module.exports = __webpack_public_path__ + "static/img/locked.b49e6b50.svg";